<template>
  <div v-if="show_historical_usage">
    <div>
      <strong>${{ format_dollar_amount(plan.average_total) }}</strong> average bill
    </div>

    <!--High-->
    <div>
      <strong>${{ plan.high?.total.toFixed(2) }}</strong> high ({{ plan.high?.months?.join(', ') }})
    </div>

    <!--Low-->
    <div>
      <strong>${{ plan.low?.total.toFixed(2) }}</strong> low ({{ plan.low?.months?.join(', ') }})
    </div>
  </div>
</template>

<script>
import UsageFilters from "src/composables/UsageFilters";
import Utilities from "src/composables/Utilities";

export default {
  name: "PlanHistoricalDetails",
  props: {
    plan: {
      type: Object
    }
  },
  setup() {
    const { show_historical_usage } = UsageFilters();
    const { format_dollar_amount } = Utilities();
    return {
      show_historical_usage,
      format_dollar_amount
    }
  }
}
</script>

<style scoped>

</style>